/**
 * @generated SignedSource<<e9f6ae71cac84727f0658d71de1613fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EquipmentCategory = "AUDIO_VIDEO" | "BATTERY" | "CABLE" | "CAMERA" | "CAMERA_ACCESSORY" | "ETC" | "KIT" | "LENS" | "LIGHTING" | "MEDIA" | "NETWORK" | "POWER" | "PRINTER" | "SECURITY" | "WORKSTATION" | "WORKSTATION_ACCESSORY" | "%future added value";
export type ReservationStatus = "CANCELLED" | "CHECKED_OUT" | "CONFIRMED" | "DRAFT" | "PICKED" | "REQUESTED" | "RETURNED" | "%future added value";
export type OpsReservationPageQuery$variables = {
  id: string;
};
export type OpsReservationPageQuery$data = {
  readonly reservation: {
    readonly checkedOutAt: any | null | undefined;
    readonly customer: {
      readonly email: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly phone: string | null | undefined;
    };
    readonly days: number;
    readonly editable: boolean;
    readonly endsAt: any;
    readonly holds: ReadonlyArray<{
      readonly asset: {
        readonly assetTag: any;
        readonly category: EquipmentCategory;
        readonly kit: {
          readonly assetTag: any;
        } | null | undefined;
        readonly name: string;
      };
      readonly id: string;
      readonly picked: boolean;
      readonly returned: boolean;
    }>;
    readonly id: string;
    readonly lines: ReadonlyArray<{
      readonly asset: {
        readonly assetTag: any;
        readonly category: EquipmentCategory;
        readonly name: string;
      };
      readonly holds: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly id: string;
    }>;
    readonly notes: string | null | undefined;
    readonly quotedTotal: any | null | undefined;
    readonly returnedAt: any | null | undefined;
    readonly startsAt: any;
    readonly status: ReservationStatus;
  } | null | undefined;
};
export type OpsReservationPageQuery = {
  response: OpsReservationPageQuery$data;
  variables: OpsReservationPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startsAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endsAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "days",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quotedTotal",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "editable",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkedOutAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "returnedAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Customer",
  "kind": "LinkedField",
  "name": "customer",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phone",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetTag",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "ReservationAsset",
  "kind": "LinkedField",
  "name": "holds",
  "plural": true,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picked",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "returned",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsReservationPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Reservation",
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ReservationLine",
            "kind": "LinkedField",
            "name": "lines",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Asset",
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v12/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ReservationAsset",
            "kind": "LinkedField",
            "name": "holds",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Asset",
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v12/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Asset",
                    "kind": "LinkedField",
                    "name": "kit",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsReservationPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Reservation",
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ReservationLine",
            "kind": "LinkedField",
            "name": "lines",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Asset",
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v12/*: any*/),
                  (v15/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ReservationAsset",
            "kind": "LinkedField",
            "name": "holds",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Asset",
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v12/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Asset",
                    "kind": "LinkedField",
                    "name": "kit",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fb55374706ce08fd01710aa5e5ef337b",
    "id": null,
    "metadata": {},
    "name": "OpsReservationPageQuery",
    "operationKind": "query",
    "text": "query OpsReservationPageQuery(\n  $id: ID!\n) {\n  reservation(id: $id) {\n    id\n    status\n    startsAt\n    endsAt\n    days\n    notes\n    quotedTotal\n    editable\n    checkedOutAt\n    returnedAt\n    customer {\n      id\n      name\n      email\n      phone\n    }\n    lines {\n      id\n      asset {\n        assetTag\n        name\n        category\n        id\n      }\n      holds {\n        id\n      }\n    }\n    holds {\n      id\n      picked\n      returned\n      asset {\n        assetTag\n        name\n        category\n        kit {\n          assetTag\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "107a1722861905906fd5d8430f04aca6";

export default node;
